/**
 * useForcedListLayoutId — wymuszony layout listy z pozycji Kreatora menu
 * (kartoteka-layout-per-menu). Wydzielone z `ModuleRecordsPage.tsx` (dotąd jedyny
 * konsument tego wzorca, dla modułów własnych z Kreatora) — teraz reużywane też
 * przez listy kartotek systemowych.
 *
 * `listRef` na aktywnej pozycji menu (`?mi=`, `useActiveMenuItem`) ma kształt
 * 'entitySlug:layoutId'. Zwraca `layoutId` TYLKO gdy `entitySlug` matchuje podany
 * `moduleSlug` — inaczej `null` (bit-identyczne z brakiem wskazania z menu; ta sama
 * pozycja menu na innej stronie/inny moduł nie ma efektu).
 *
 * Wołający dokleja zwrócony `layoutId` jako sufiks `::layout-<id>` do WŁASNEGO
 * `tableId` (rozpoznawany przez `useTableLayout`'s `FORCED_LAYOUT_RE`) i przekazuje
 * TĘ SAMĄ zmienną `tableId` do WSZYSTKICH miejsc, które go dziś przyjmują na danej
 * stronie (`ConfigurableTable`, `ListTopWidgets`, `ListFilterBar`) — inaczej widżety
 * i tabela renderują dwa różne layouty (desync, nie błąd kompilacji).
 *
 * `moduleSlug` przyjmuje też `undefined` — `ModuleRecordsPage.tsx` bierze go z
 * `useParams()` (react-router typuje parametry trasy jako `string | undefined`
 * niezależnie od podanego generyka); brak sluga = brak dopasowania, `null` bez
 * dodatkowego kodu u wołającego.
 */

import { useMemo } from 'react';

import { useActiveMenuItem } from '@/hooks/useActiveMenuItem';
import { parseMenuViewRef } from '@/lib/module-templates/template-layouts';

export function useForcedListLayoutId(moduleSlug: string | undefined): string | null {
  const activeMenuItem = useActiveMenuItem();

  return useMemo(() => {
    if (!moduleSlug || !activeMenuItem?.listRef) return null;
    const parsed = parseMenuViewRef(activeMenuItem.listRef);
    if (!parsed || parsed.entitySlug !== moduleSlug) return null;
    return parsed.viewSlug;
  }, [activeMenuItem?.listRef, moduleSlug]);
}
